import { createFeatureSelector } from '@ngrx/store';
import { AdminCryptoPaymentMethodsState } from './crypto-payment-methods-admin.reducer';

export const selectAdminCryptoPaymentMethods =
  createFeatureSelector<AdminCryptoPaymentMethodsState>('cryptoPaymentMethodsAdmin');
